/**
 * 统一配置管理
 * 集中管理所有API地址、环境配置等
 */

// 环境配置
const ENV = {
  development: 'development',
  production: 'production'
}

// 当前环境
const currentEnv = process.env.NODE_ENV || ENV.development

// API配置
const API_CONFIG = {
  // 开发环境
  development: {
    // 开发环境通过 vue.config.js 代理转发到 https://mhbdev.medisyn.cc:8091/medisyn-hub
    baseURL: '/proxy-server',
    timeout: 10000
  },
  // 生产环境
  production: {
    // 生产环境使用相对路径，通过nginx代理到后端8080端口
    baseURL: '/medisyn-hub',
    timeout: 700000
  }
}

// 获取当前环境的API配置
export const getApiConfig = () => {
  return API_CONFIG[currentEnv] || API_CONFIG[ENV.development]
}

// 导出基础URL
export const BASE_URL = getApiConfig().baseURL

// 导出完整API地址（带斜杠）
export const API_BASE_URL = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`

// 导出Vue原型上的URL（兼容现有代码）
export const VUE_PROTOTYPE_URL = API_BASE_URL

// 其他配置
export const APP_CONFIG = {
  name: '岚医全域医疗智能体',
  version: '1.0.0',
  contact: '1832910768@qq.com'
}

export default {
  API_CONFIG,
  BASE_URL,
  API_BASE_URL,
  VUE_PROTOTYPE_URL,
  APP_CONFIG,
  currentEnv
}
